export const servicesPerAppName = 'Sites Services'